import * as React from "react";

export const Billing = (props: BillingProps) => {
  return <div>Free for the private beta. Thank you!</div>;
};

interface BillingProps {}
